export const ANONYMOUS_USER_ID = '00000000-0000-0000-0000-000000000003';
export const VINCI_SUPPORT_EMAIL = 'vinci_support@vinciworks.com';
export const MIN_WIDTH_TO_SHOW_FULL_MENU = 1560;
